/**
 * MangoMark — Grafty's logo mark. A real mango (not a round orange): an
 * asymmetric plump silhouette with a yellow→orange gradient, a red cheek blush,
 * a soft highlight, and a clear leaf. Bright enough to pop on dark themes.
 * Shared by the app sidebar and the login screen.
 */
export function MangoMark({ size = 40, style }: { size?: number; style?: React.CSSProperties }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 54" fill="none" style={style} aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="gm-body" x1="0.2" y1="0" x2="0.8" y2="1">
          <stop offset="0" stopColor="#FFE05A" />
          <stop offset="0.5" stopColor="#F7A21E" />
          <stop offset="1" stopColor="#E0620F" />
        </linearGradient>
        <linearGradient id="gm-leaf" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#62C84B" />
          <stop offset="1" stopColor="#2D6A2F" />
        </linearGradient>
        <radialGradient id="gm-blush" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="#EF5A36" stopOpacity="0.55" />
          <stop offset="1" stopColor="#EF5A36" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* whole mango leans slightly, like the emoji */}
      <g transform="rotate(-15 24 28)">
        {/* stem + leaf at the shoulder */}
        <path d="M23 9 C22 4 21 2 25 1" stroke="#6b4a2a" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M25 1 C34 -2 40 4 33 8 C28 9 25 5 25 1 Z" fill="url(#gm-leaf)" />
        <path d="M27 3 C31 4 33 6 33 8" stroke="rgba(255,255,255,0.45)" strokeWidth="0.9" strokeLinecap="round" fill="none" />

        {/* mango body — oblong teardrop: full shoulder up top, tapering to a beak */}
        <path d="M23 8 C35 8 39 17 39 27 C39 38 33 50 22 52 C20 52 19 51 19 49 C12 46 7 37 7 27 C7 17 12 8 23 8 Z" fill="url(#gm-body)" />
        {/* cheek blush (lower belly) */}
        <ellipse cx="29" cy="36" rx="11" ry="14" fill="url(#gm-blush)" />
        {/* highlight on the shoulder */}
        <ellipse cx="16" cy="20" rx="4.5" ry="9" fill="rgba(255,255,255,0.30)" transform="rotate(-12 16 20)" />
        {/* subtle ridge */}
        <path d="M22 15 C19 26 20 38 24 49" stroke="#C25A0E" strokeWidth="1.4" strokeLinecap="round" fill="none" opacity="0.22" />
      </g>
    </svg>
  )
}
